export const environment = {
  production: true,
  API_URL: "https://api.ltruckgeofret.fr"
};



// WEBPACK FOOTER //
// /usr/src/app/src/environments/environment.ts